import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth as useClerkAuth } from '@clerk/react';
import { useAuth } from '../hooks/useAuth';
import Loader from '../components/common/Loader';

export default function PrivateRoute({ children }) {
  const { user, loading, authIssue } = useAuth();
  const { isLoaded, isSignedIn } = useClerkAuth();
  const location = useLocation();

  if (!isLoaded || loading) return <Loader fullscreen />;

  if (isSignedIn && !user && authIssue === 'admin_signup_limit_reached') {
    return <Navigate to="/sign-in" state={{ from: location, reason: 'admin_signup_limit_reached' }} replace />;
  }

  if (isSignedIn && !user && authIssue === 'forbidden') {
    return <Navigate to="/sign-in" state={{ from: location, reason: 'forbidden' }} replace />;
  }

  // Signed-in Clerk session but app profile still resolving: keep loader, do not bounce to sign-in.
  if (isSignedIn && !user) return <Loader fullscreen />;

  if (!isSignedIn) return <Navigate to="/sign-in" state={{ from: location }} replace />;
  if (!user) return <Navigate to="/sign-in" state={{ from: location }} replace />;

  return children;
}